import {
  ACCEPTED_IMPORT_EXTENSIONS,
  MAX_IMPORT_FILE_SIZE,
} from "./importConstants";

export const validateImportFile = (file: File): string | null => {
  const extension = `.${(file.name.split(".").pop() ?? "").toLowerCase()}`;

  if (!ACCEPTED_IMPORT_EXTENSIONS.includes(extension)) {
    return "paymentsReceived.import.invalidType";
  }

  if (file.size > MAX_IMPORT_FILE_SIZE) {
    return "paymentsReceived.import.fileTooLarge";
  }

  return null;
};
